module.exports = __webpack_public_path__ + "static/media/Great_Waters_at_Reynolds_Lake_Oconee_-_Oct_2019.5df3bf86.jpg";